"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenEventNames = void 0;
/**
 * Token events dictionary
 */
let TokenEventNames = exports.TokenEventNames = /*#__PURE__*/function (TokenEventNames) {
  /**
   * Event name for public token
   */
  TokenEventNames["PUBLIC_ACCESS"] = "publicTokenUpdated";
  /**
   * Event name for user token
   */
  TokenEventNames["USER_ACCESS"] = "tokenUpdated";
  return TokenEventNames;
}({});
//# sourceMappingURL=TokenEventNames.js.map